import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";

import copy from "copy-to-clipboard";
import { grey } from "@mui/material/colors";
import BigCompanyIcon from "../../../../media/images/icons/company-big-icon";
import ArrowDownSVG from "../../../../media/images/icons/arrow-down";
import CustomButton from "../../../components/CustomButton";
import CopyClipboardIcon from "../../../../media/images/icons/copy-icon";

export default function BazargahSupportInfo() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const [acceptCopy, setAcceptCopy] = useState({
    address: false,
    phoneNumber: false,
  });

  const handleCopyText = (text: string, key: "address" | "phoneNumber") => {
    copy(text);
    setAcceptCopy((prev) => ({ ...prev, [key]: true }));
    const timer = setTimeout(() => {
      setAcceptCopy((prev) => ({ ...prev, [key]: false }));
    }, 2000);
    return () => clearTimeout(timer);
  };

  return (
    <Box
      sx={{
        backgroundColor: "bgColor.white",
        paddingX: "8px",
        borderRadius: "16px",
        marginTop: "16px",
        border: "1px solid gray",
        display: "flex",
        flexDirection: "column",
        paddingY: "8px",
      }}
    >
      <Box
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          backgroundColor: open ? "success.main" : "",
          borderRadius: "10px",
          padding: "12px 8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <BigCompanyIcon
            size={28}
            color={
              open ? theme.palette.success.light : theme.palette.success.main
            }
          />
          <Typography
            sx={{
              fontWeight: "700",
              color: open ? "#fff" : "success.main",
              fontSize: "16px",
            }}
          >
            اطلاعات تماس پشتیبانی بازارگاه
          </Typography>
        </Box>
        <Box
          sx={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s",
          }}
        >
          <ArrowDownSVG
            size={16}
            color={open ? "#fff" : theme.palette.primary.main}
          />
        </Box>
      </Box>
      <Box
        sx={{
          mt: open ? 1 : 0,
          overflow: "hidden",
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",
          borderRadius: "8px",
          backgroundColor: theme.palette.bgColor.grey100,
          maxHeight: open ? "150px" : "0px",
          paddingY: open ? "8px" : "0px",
          transition: "all 0.3s ease",
          paddingX: "8px",
        }}
      >
        <Typography
          sx={{
            color: theme.palette.primary[700],
            fontSize: "14px",
            fontWeight: "700",
          }}
        >
          مرکز تماس پشتیبانی:{" "}
        </Typography>
        <Typography
          sx={{
            mt: 1,
            color: theme.palette.primary[700],
            fontSize: "12px",
            fontWeight: "700",
          }}
        >
          بندرعباس، سه راه جانباز، بلوار پاسداران، نام آوران 7. ساختمان مسکو طبقه اول
        </Typography>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "end",
          }}
        >
          <CustomButton
            onClick={() =>
              handleCopyText(
                `          بندرعباس، سه راه جانباز، بلوار پاسداران، نام آوران 7. ساختمان مسکو طبقه اول
`,
                "address"
              )
            }
            title={acceptCopy.address ? "کپی شد" : "کپی آدرس"}
            bgColor={theme.palette.primary[700]}
            fSize="12px"
            gap="6"
            fWeight="600"
            px="4px"
            py="4px"
            borderRadius="6px"
            icon1={<CopyClipboardIcon size={18} color={"#fff"} />}
          />
        </Box>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              paddingX: "8px",
              paddingY: "6px",
              borderRadius: "8px",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: "#105DAA",
              }}
            >
              09108107185{" "}
            </Typography>
            <CustomButton
              onClick={() => handleCopyText("09108107185", "phoneNumber")}
              title={acceptCopy.phoneNumber ? "کپی شد" : "کپی شماره"}
              bgColor={theme.palette.primary[700]}
              fSize="12px"
              gap="6"
              fWeight="600"
              px="4px"
              py="4px"
              borderRadius="6px"
              icon1={<CopyClipboardIcon size={18} color={"#fff"} />}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
